import React from 'react';

export default function Example() {
  return (
<div className="flex justify-center items-center gap-x-2 bg-red-500 py-4">
  <p className="text-white mt-0">
      We now offer secure texting for PACE patients. | 
  </p>
  <div>
    <a href="/weltel" className='text-white underline hover:text-blue-900 transition-all ease-in-out duration-300'>
      Click to enroll!
    </a>
  </div>
</div>

  );
}
